import { createAction, props } from '@ngrx/store';

import { ProductBox } from 'app/shared/components/product-box/models';

export const updateProductBoxes = createAction(
    '[ProductBox] Update ProductBoxes',
    props<{ productBoxList: ProductBox[] }>(),
);
